import React from 'react';
import { Users, DollarSign, TrendingUp } from 'lucide-react';
const BusinessFeatures: React.FC = () => {
  return <div className="grid md:grid-cols-3 gap-6 mb-8">
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary-blue/10 text-primary-blue mb-4 mx-auto">
          <Users className="h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold text-center mb-2">300 Refer Accounts</h3>
        <p className="text-gray-600 text-center">Each node gives you access to 300 paying customer accounts with admin privileges. Each admin account can manage users as per plan a total up to 1,800,000 active referrals.  You can add unlimited nodes by upgrading.</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary-blue/10 text-primary-blue mb-4 mx-auto">
          <DollarSign className="h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold text-center mb-2">Flexible Pricing</h3>
        <p className="text-gray-600 text-center">You control pricing for your customers with plans ranging from $29 to $299 per month, with only a minimum sales price on each on each plan no maximum price requirement per plan.</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary-blue/10 text-primary-blue mb-4 mx-auto">
          <TrendingUp className="h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold text-center mb-2">Revenue Share Model</h3>
        <p className="text-gray-600 text-center"> No monthly fees - you only pay from sales you make. You just start with a one time setup fee. Your revenue share increases as your volume grows - up to 45% for top performers.</p>
      </div>
    </div>;
};
export default BusinessFeatures;